<div class="main-container lg-view" [ngClass]="{'hide-actions-container' : !hasBottomMessages() || !hasReturnButton() }">
	<div class="header">		
		<h3 class="job-name">{{job.jobName}}</h3>
		<div>
			<button *ngIf="!showCompletedOnly && job.enableStartMyWorkFeature && !isJobCancelled" class="start-my-work-btn" mat-raised-button color="primary" (click)="handleStartMyWork($event)">
				{{startByWorkButtonLabel}}
			</button>
			<button *ngIf="!isJobCancelled" class="start-my-work-btn documents-btn" mat-raised-button color="primary" (click)="onDocumentsClick($event)">
				Documents
			</button>
		</div>
		<h4>
			<span *ngIf="!showCompletedOnly">Active</span> 
			<span class="completed" *ngIf="showCompletedOnly">Completed</span> 
			Digital log forms</h4>
		<h5 *ngIf="job.siteAddress">{{ job.siteAddress }}</h5>
		<div class="filter-container" *ngIf="!isJobCancelled">
				<form [formGroup]="searchForm">
					<div class="filter-search">
						<mat-form-field id="searchKeyword">
							<mat-label>Search</mat-label>
							<input matInput type="text" formControlName="searchInput">
							<button mat-button *ngIf="searchForm.get('searchInput')?.value" matSuffix mat-icon-button aria-label="Clear" (click)="onSearchClear('searchInput')">
								<mat-icon>close</mat-icon>
							</button>
						</mat-form-field>
					</div>				
				</form>
		</div>
	</div>
	<div class="body">
		<app-loader [isInline]="true" [hasTransparency]="true" *ngIf="isLoading" ></app-loader>
		<ng-container *ngIf="customFormRequestsList?.length && !isJobCancelled">
			<app-loader [isInline]="true" [hasTransparency]="true" *ngIf="isLoading" ></app-loader>
			<div class="job-form-container" *ngFor="let item of customFormRequestsList">
				<ng-container *ngIf="item.recurrenceFrequencyId !== 9">
					<button mat-flat-button type="button" (click)="navigateToForm(item.jobDigitalLogFormRequestId)">
						<div class="form-button-details">
							<span class="name" [class.emergency]="item.isEmergency">{{ item.formName }}</span>
							<span class="details">{{ item.recurrenceFrequencyName}}</span>
							<span class="details" *ngIf="item.lastLogEntry">Collected last time on {{
								moment.parseZone(item.lastLogEntry).format('MM/DD/YYYY') }}</span>
							<span class="details" *ngIf="item.lastLogEntry">Days since last collection: {{
								item.daysSinceLastLogEntry}}</span>
						</div>
						<div class="form-button-actions">
							<button mat-icon-button
								(click)="navigateToCalendar(item.jobDigitalLogFormRequestId); $event.preventDefault(); $event.stopPropagation();">
								<mat-icon>calendar_today</mat-icon>
							</button>
		
							<button mat-icon-button [class.highlighted]="item.isDisabled" class="svg-smaller-icon"
								(click)="selectDigitalLogForm(item); offlineRangesModal.open({ data: item, openMatDrawer$: openMatDrawer$ }); $event.preventDefault(); $event.stopPropagation();">
								<mat-icon [svgIcon]="'stop_sign'"></mat-icon>
							</button>
						</div>
					</button>
				</ng-container>
				<!-- on demand -->
				<ng-container *ngIf="item.recurrenceFrequencyId === 9"> 
					<button mat-flat-button type="button" (click)="navigateToForm(item.jobDigitalLogFormRequestId)" [disabled]="isDeleteDisabled">
						<div class="form-button-details">
							<span class="name" [class.emergency]="item.isEmergency">{{ item.formName }}</span>
							<div>
								<span class="alias" *ngIf="!!formAlias(item)">{{formAlias(item)}}</span>								
								<span class="alias-identifier" *ngIf="item.aliasIdentifier !== null"> [{{item.aliasIdentifier}}]</span>
							</div>
							<!-- <span class="details">Created on {{moment.parseZone(item.createdOn).format('MM/DD/YYYY')}}</span> -->							
							<!-- <span class="details" *ngIf="item.lastCollectedOn && !showCompletedOnly">Last Collected on {{moment.parseZone(item.lastCollectedOn).format('MM/DD/YYYY')}}</span> -->
							<span class="details" *ngIf="showCompletedOnly && item.completedOn">Completed On {{moment.parseZone(item.completedOn).format('MM/DD/YYYY')}}</span>
							<!-- <span class="details on-demand">{{ item.recurrenceFrequencyName}} by {{item.requestedBy}}</span> -->
							<div class="on-demand-request-progress-wrapper">
								<on-demand-request-progress [label]="'Sections'" [percentValue]="item.sectionProgressPercent"></on-demand-request-progress>
								<on-demand-request-progress [label]="'Overall Progress'" [percentValue]="item.overallProgressPercent"></on-demand-request-progress>
							</div>
						</div>
						<div class="form-button-actions">
							<button mat-icon-button [class.highlighted]="item.isDisabled" class="delete-icon" [disabled]="isDeleteDisabled"
								(click)="onDemandConfirmationModal.open({ data: item, openMatDrawer$: openMatDrawer$ }); $event.preventDefault(); $event.stopPropagation();">
								<mat-icon>delete</mat-icon>
							</button>
						</div>
					</button>
				</ng-container>
			</div>
		</ng-container>
	</div>


	<div class="empty-message-container" *ngIf="!customFormRequestsList?.length && !isJobCancelled">There are no digital log forms!</div>

	<div class="empty-message-container" *ngIf="isJobCancelled">The current Job is no longer accessible. <br> Please contact Customer Support for more details.</div>
</div>

 <div class="actions-container md-view" *ngIf="(hasBottomMessages() || hasReturnButton() || job.allowClearingRemainingDlWork) && !isJobCancelled">
	<ng-container
		*ngIf="hasReturnButton()">
		<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'../'"></action-button>
	</ng-container>

	<ng-container *ngIf="!showCompletedOnly && job.allowClearingRemainingDlWork">
		<action-button [icon]="null" [name]="clearRemainingWorkButtonLabel" [clickAction]="handleClearRemainingWork.bind(self)"></action-button>
	</ng-container>

	<div class="actions-placeholder-message"
		*ngIf="hasBottomMessages()">
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
		<span
			*ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.BothDisabled }}</span>
	</div>
</div>

<inspection-report-selector [isVisible]="isReportSelectorVisible && !isJobCancelled" [token]="jobToken" [siteAddress]="job.siteAddress" (close)="onCloseReportSelector($event)"></inspection-report-selector>

<generic-modal #offlineRangesModal [hideOnBackdropClick]="false">
	<ng-template #modalHeading let-data="data">
		{{ data.data.formName }}
	</ng-template>

	<ng-template #modalBody let-data="data">
		<mat-drawer-container class="example-container" [hasBackdrop]="false">
			<mat-drawer-content>

				<div class="main-container">
					<app-loader *ngIf="isLoading"></app-loader>

					<ng-container *ngIf="!isLoading">
						<form class="main-form disable-form" [formGroup]="disabledFormGroup">
							<fieldset>
								<label>
									This Log Applies to My Site?
								</label>
								<mat-radio-group class="disable-radio-group" aria-label="This Log Applies to My Site" formControlName="isChecked">
									<mat-radio-button [value]="true">Yes</mat-radio-button>
									<mat-radio-button [value]="false" (click)="offlineRangesModal.hide(); notPerformedConfirmationModal.open(data)">No</mat-radio-button>
								  </mat-radio-group>
							</fieldset>
						</form>

						<form class="main-form">
							<fieldset class="intervals-list-container">
								<legend>OFFLINE</legend>
								<div class="interval-heading">
									<div class="interval-label-container" [ngClass]="{'hidden' : !offlineRanges?.length}">
										<div class="interval-label">
											Date Range
										</div>
									</div>
									<div class="add-container">
										<button mat-flat-button
											(click)="openOfflineRangeEdit(); data.openMatDrawer$.next(true)">
											<mat-icon>add</mat-icon>
											<span>Add</span>
										</button>
									</div>
								</div>
								<div class="empty-message-container" *ngIf="!offlineRanges?.length">
									There are no offline ranges defined!
								</div>
								<div class="list-container">
									<ng-container *ngIf="!!offlineRanges?.length">
										<div class="interval-container" *ngFor="let range of offlineRanges">
											<div class="interval-label date-range">
												{{ moment(range.startDate).format('ll') }} - {{
												moment(range.endDate).format('ll') }}
											</div>

											<div class="interval-actions">
												<button mat-icon-button
													(click)="openOfflineRangeEdit(range); data.openMatDrawer$.next(true)">
													<mat-icon>edit</mat-icon>
												</button>

												<button mat-icon-button
													(click)="offlineRangeToBeDeleted = range; data.openMatDrawer$.next(true)">
													<mat-icon>delete</mat-icon>
												</button>
											</div>
										</div>
									</ng-container>
								</div>
							</fieldset>
						</form>
					</ng-container>
				</div>
			</mat-drawer-content>

			<mat-drawer #operationsDrawer position="end" [opened]="data.openMatDrawer$ | async"
				(openedChange)="!$event && (isOfflineRangeEditMode = $event); !$event && (offlineRangeToBeDeleted = null)"
				class="operations-drawer">
				<ng-container *ngIf="offlineRangeFormGroup && isOfflineRangeEditMode && !offlineRangeToBeDeleted">
					<p *ngIf="!offlineRangeFormGroup.get('jobDigitalLogFormOfflineRangeId').value">Add a new
						offline range</p>
					<p *ngIf="offlineRangeFormGroup.get('jobDigitalLogFormOfflineRangeId').value">Edit offline
						range</p>

					<form [formGroup]="offlineRangeFormGroup" class="brief-form-container">
						<mat-form-field class="calendar" [floatLabel]="'always'">
							<mat-label>Choose start date</mat-label>
							<input matInput [matDatepicker]="startPicker" formControlName="startDate">
							<mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
							<mat-datepicker #startPicker></mat-datepicker>
						</mat-form-field>

						<mat-form-field class="calendar" [floatLabel]="'always'">
							<mat-label>Choose end date</mat-label>
							<input matInput [matDatepicker]="endPicker"
								[min]="offlineRangeFormGroup.get('startDate').value || beginningOfTime"
								formControlName="endDate">
							<mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
							<mat-datepicker #endPicker></mat-datepicker>
						</mat-form-field>
					</form>
					<ng-container *ngIf="offlineRangeFormGroup.get('startDate').value && offlineRangeFormGroup.get('endDate').value">
						<div class="warning-container">
							<p>Please note that any measurements taken between {{ moment(offlineRangeFormGroup.get('startDate').value).format('ll') }}
								and {{ moment(offlineRangeFormGroup.get('endDate').value).format('ll') }} will not appear in your Binder!
							</p>
							<form [formGroup]="confirmationFormGroup">
								<mat-checkbox formControlName="isChecked">Check here to confirm</mat-checkbox>
							</form>
						</div>
					</ng-container>
				</ng-container>

				<ng-container *ngIf="!isOfflineRangeEditMode && !!offlineRangeToBeDeleted">
					<div>
						<p>Delete value</p>
						<p>
							{{ moment(offlineRangeToBeDeleted.startDate).format('ll') }} - {{
							moment(offlineRangeToBeDeleted.endDate).format('ll') }}
						</p>
						<p class="delete-message-content">Are you sure you want to delete the offline range?</p>
					</div>
				</ng-container>
			</mat-drawer>
		</mat-drawer-container>
	</ng-template>

	<ng-template #modalActions>
		<ng-container *ngIf="!isOfflineRangeEditMode && !offlineRangeToBeDeleted">
			<button mat-flat-button class="secondary"
				(click)="clearOfflineRangesList(); offlineRangesModal.hide()">Close</button>
		</ng-container>

		<ng-container *ngIf="isOfflineRangeEditMode">
			<button mat-flat-button (click)="saveOfflineRange()"
				[disabled]="offlineRangeFormGroup.invalid || !confirmationFormGroup.get('isChecked').value">Save</button>
			<button mat-flat-button class="secondary"
				(click)="openMatDrawer$.next(false); resetConfirmationCheckbox(); isOfflineRangeEditMode = false">Cancel</button>
		</ng-container>

		<ng-container *ngIf="!!offlineRangeToBeDeleted">
			<button mat-flat-button (click)="deleteOfflineRange()">Yes</button>
			<button mat-flat-button class="secondary"
				(click)="openMatDrawer$.next(false); offlineRangeToBeDeleted = null">No</button>
		</ng-container>
	</ng-template>
</generic-modal>

<generic-modal #notPerformedConfirmationModal>
	<ng-template #modalHeading let-data="data">
		{{ data.data.formName }}
	</ng-template>

	<ng-template #modalBody>
		<div class="main-container">
			<p>This Log will be permanently removed from your site.<br>Are you sure?</p>
			<form [formGroup]="inputForm" class="main-form remove-form">
				<mat-checkbox class="" formControlName="isReportDateRequired" (change)="onSpecifiedDateChange($event)">Keep data up to a specified date</mat-checkbox>
				<mat-form-field class="calendar">
					<mat-label>Select Date</mat-label>
					<input matInput [matDatepicker]="keepDataUpToPicker"
					formControlName="keepDataUpTo"
					[disabled]="!isSpecifiedDateEnabled"
					[max]="today">
					<mat-datepicker-toggle matSuffix [for]="keepDataUpToPicker"></mat-datepicker-toggle>
					<mat-datepicker #keepDataUpToPicker></mat-datepicker>
					<mat-icon class="clear-button" (click)="clearDate()">clear
					</mat-icon>
				</mat-form-field>
				<p class="bold">Are you sure you want to proceed?</p>
				<mat-form-field>
					<input matInput type="text" formControlName="input">
				</mat-form-field>
				<div class="input-text">
					<span>
						please type <span class="important">remove</span> to confirm
					</span>
				</div>
			</form>
		</div>

	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-flat-button
			(click)="notPerformedConfirmationModal.hide(); offlineRangesModal.open(data);">Cancel</button>
		<button mat-flat-button
			(click)="setAsNotApplicable(data.data); notPerformedConfirmationModal.hide();" [disabled]="!isConfirmEnable || inputForm.invalid">Confirm</button>
	</ng-template>
</generic-modal>

<generic-modal #onDemandConfirmationModal>
	<ng-template #modalHeading let-data="data">
		{{ data.data.formName }}
	</ng-template>

	<ng-template #modalBody let-data="data">
		<ng-container *ngIf="data.data.isCompleted">
			<div class="main-container">
				<p>Are you sure you want to delete this completed "On Demand" Log Form that was submitted on 
					{{ moment.parseZone(data.data.lastLogEntry).format('MM/DD/YYYY') }}
				</p>
			</div>
		</ng-container>
		<ng-container *ngIf="!data.data.isCompleted">
			<div class="main-container">
				<p>Are you sure you want to delete this pending "On Demand" Log Form that was created on
					{{ moment.parseZone(data.data.createdOn).format('MM/DD/YYYY') }}</p>
			</div>
		</ng-container>
	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-flat-button
			(click)="onDemandConfirmationModal.hide()">Cancel</button>
		<button mat-flat-button
			(click)="deleteOnDemandDLForm(data.data); onDemandConfirmationModal.hide();" [disabled]="isDeleteDisabled">Confirm</button>
	</ng-template>
</generic-modal>

<generic-modal #emptyOnDemandLogsModal>
	<ng-template #modalBody>
		<div class="main-container empty-on-demand">
			<p>
				There are no "On Demand" Log Forms available.
			</p>
		</div>
	</ng-template>
	<ng-template #modalActions>
		<button mat-flat-button (click)="emptyOnDemandLogsModal.hide()">Ok</button>
	</ng-template>
</generic-modal>

<generic-modal #emptyConfigOnDemandLogsModal>
	<ng-template #modalBody>
		<div class="main-container empty-on-demand">
			<p>
				There are no Configurable "On Demand" Log Forms available.
			</p>
		</div>
	</ng-template>
	<ng-template #modalActions>
		<button mat-flat-button (click)="emptyConfigOnDemandLogsModal.hide()">Ok</button>
	</ng-template>
</generic-modal>

<generic-modal #missingOnDemandConfigProfileModal>
	<ng-template #modalBody>
		<div class="main-container empty-on-demand">
			<p>
				This feature was not yet configured. Please speak to your admin for more details.
			</p>
		</div>
	</ng-template>
	<ng-template #modalActions>
		<button mat-flat-button (click)="missingOnDemandConfigProfileModal.hide()">Ok</button>
	</ng-template>
</generic-modal>

<generic-modal #missingConfigProfileModal>
	<ng-template #modalBody>
		<div class="main-container empty-on-demand">
			<p>
				This setup was not yet configured.
			</p>
			<p>
				Please contact your admin for more details.
			</p>
		</div>
	</ng-template>
	<ng-template #modalActions>
		<button mat-flat-button (click)="missingConfigProfileModal.hide()">Ok</button>
	</ng-template>
</generic-modal>

<generic-modal #startMyWorkProgressModal [hideOnBackdropClick]="false">
	<ng-template #modalBody let-data="data">
		<div class="main-container start-my-work-progress" >			
			<p class="progress-message" [class.error]="startMyWorkProgress.hasError" [class.success]="startMyWorkProgress.isWorkStarted">
				{{startMyWorkProgress.progressMessage}}		
				<app-loader *ngIf="startMyWorkProgress.isWorkStarting && startMyWorkProgress.hasProfileOverlap" [hasTransparency]="true" [isInline]="true"></app-loader>		
			</p>
		</div>
	</ng-template>
	<ng-template #modalActions>
		<button *ngIf="startMyWorkProgress.hasError" mat-flat-button (click)="startMyWorkProgressModal.hide()">Ok</button>
		<button *ngIf="!startMyWorkProgress.hasError && startMyWorkProgress.isWorkStarted" mat-flat-button (click)="reloadPage()">Ok</button>
		<!-- <button *ngIf="!startMyWorkProgress.hasError && !startMyWorkProgress.isWorkStarted && startMyWorkProgress.hasProfileOverlap" [disabled]="startMyWorkProgress.isWorkStarting" mat-raised-button color="primary" (click)="setMyWorkToToday()">Yes</button>
		<button *ngIf="!startMyWorkProgress.hasError && !startMyWorkProgress.isWorkStarted && startMyWorkProgress.hasProfileOverlap" [disabled]="startMyWorkProgress.isWorkStarting" mat-flat-button (click)="consolidateMyWork()">No</button> -->
	</ng-template>
</generic-modal>

<generic-modal #clearRemainingWorkModal [hideOnBackdropClick]="false">
	<ng-template #modalBody let-data="data">
		<div class="main-container start-my-work-progress" >			
			<p class="progress-message" [class.error]="clearRemainingWorkProgress.hasError" [class.success]="clearRemainingWorkProgress.isCleanCompleted">
				{{clearRemainingWorkProgress.progressMessage}}
				<app-loader *ngIf="clearRemainingWorkProgress.isCleanInProgress" [hasTransparency]="true" [isInline]="true"></app-loader>		
			</p>
		</div>
	</ng-template>
	<ng-template #modalActions>
		<button *ngIf="clearRemainingWorkProgress.hasError" mat-flat-button (click)="clearRemainingWorkModal.hide()">Ok</button>
		<button *ngIf="!clearRemainingWorkProgress.hasError && clearRemainingWorkProgress.isCleanCompleted" mat-flat-button (click)="reloadPage()">Ok</button>
		<button *ngIf="!clearRemainingWorkProgress.hasError && !clearRemainingWorkProgress.isCleanCompleted" [disabled]="clearRemainingWorkProgress.isCleanInProgress" mat-raised-button color="primary" (click)="clearRemainingWork()">Yes</button>
		<button *ngIf="!clearRemainingWorkProgress.hasError && !clearRemainingWorkProgress.isCleanCompleted" [disabled]="clearRemainingWorkProgress.isCleanInProgress" mat-flat-button (click)="clearRemainingWorkModal.hide()">No</button>
	</ng-template>
</generic-modal>

<generic-modal #profileGroupsSelectionModal>
	<ng-template #modalHeading>
		<h3>Select the group setup to start</h3>
	</ng-template>
	<ng-template #modalBody>
		<div class="main-container groups-selection" >
			<div class="profile-groups-list">
				<button *ngFor="let profileGroup of profileGroups" 
						mat-raised-button 
						color="primary" 
						class="profile-group-button"
						(click)="selectProfileGroup(profileGroup)">
					{{ profileGroup.name }}
				</button>
			</div>
		</div>
	</ng-template>
	<ng-template #modalActions>
		<button mat-flat-button (click)="profileGroupsSelectionModal.hide()">Cancel</button>
	</ng-template>
</generic-modal>

<generic-modal #futureLogDateConfirmationModal [hideOnBackdropClick]="true">
	<ng-template #modalHeading let-data="data">
		<div class="future-log-date-heading">
			<div>
			Forms with Future Log Dates
			</div>
			<div class="future-log-date-subheading">
				<hr />
			</div>
		</div>
	</ng-template>
	<ng-template #modalBody>
		<div class="main-container future-log-date-confirmation">
			<ng-container>
				<p>Some of the Forms have future Log Dates and may require updates.</p>
				<p>Do you want to proceed as it is?</p>
			</ng-container>
		</div>
	</ng-template>

	<ng-template #modalActions>
		<button mat-flat-button (click)="proceedWithFutureLogDates()">Proceed</button>
		<button mat-flat-button (click)="closeFutureLogDateConfirmation()">Cancel</button>
	</ng-template>
</generic-modal>